import upload from '@/features/upload/store'
import projectList from '@/features/projectList/store'
import matchFields from '@/features/matchFields/store'
import auth from '@/features/auth/store'
import job from '@/features/job/store'
import socket from '@/system/socket/store'

const modules = {
  upload,
  projectList,
  matchFields,
  auth,
  job,
  socket
}

export default modules
